/**
 * ajax.js
 *
 * @Author: jruif
 * @Date: 2017/7/16 上午2:20
 */

import axios from 'axios';
import { Modal } from 'neatui/es/index.mobile';
import extend from 'object-assign';
import { isObject, isFunction /* , isUndefined */ } from './isType';
// import stringifyJSON from './stringifyJSON';
import transformRequest from './transformRequest';
import { modifyHeader, modifyUrl } from './ajaxModifyer';
import getTraceId from './getTraceId';
import WholeLink from './wholeLink';
import { isReportWholeLink } from './csConfig';
// 是否上报全链路

const noop = (...argv) => argv;
const isMobilePlatform = /(iPhone|iPod|Android|ios)/i.test(navigator.userAgent);
const isToReg = /(index.html#\/to_reg)/i.test(window.location.href);
const isAutoReg = /from=autoreg/i.test(window.location.href);
const reject = (msg, other) => (response, rs) => {
  let message;
  if ([0, 2, 100001, 100002, 100003, 100004, 100005, 100006, 110021].indexOf(+rs.code) > -1) {
    message = [0, 2, 110021].indexOf(+rs.code) > -1 ? `${msg}：${rs.msg}` : rs.msg;
  } else {
    message = msg || rs.msg;
  }
  response.data = extend(
    rs,
    {
      msg: message,
    },
    other,
  );

  return Promise.reject(response);
};

const status = {
  '1': response => response, // 成功
  '0': reject('操作失败'), // 旧错误码
  '2': reject('操作失败'),
  '100030': reject('长时间未登录，信息已失效，为了保证账号安全，请验证手机号信息。', {
    url: '/index.html#/account-protect',
    showTip: true,
    isIntra: true, // 内部跳转
  }),
  '100037': reject('为了您的账号安全，需要您进行登录验证!', {
    url: '/index.html#/account-protect',
    showTip: true,
    isIntra: true, // 内部跳转
    newWindow: true, // 新窗口打开
  }),
  '100001': reject('参数为空'),
  '100002': reject('参数错误'),
  '100003': reject('数据不存在'),
  '100004': reject('参数超出范围'),
  '100005': reject('数据已存在'),
  '100006': reject('请选择上传文件'),
  // '100011': reject('用户已经关注过'),
  // '100012': reject('用户未关注过'),
  // '100013': reject('用户已经取消关注'),
  '100021': reject('未获取到登录信息,请点击确定完成登录', {
    url: isToReg
      ? isAutoReg
        ? '/index.html#/to_reg?type=loginEmail&from=auto'
        : '/index.html#/to_reg?type=loginEmail'
      : isMobilePlatform
      ? `https://dl.reg.163.com/ydzj/maildl?product=subscribe&pdconf=yddl_subscribe_conf&mc=DF3031&curl=${encodeURIComponent(
          window.location.href,
        )}`
      : `/login.html?url=${encodeURIComponent(window.location.href)}`,
    isIntra: isToReg,
    // showTip: isToReg,
  }),
  '110021': reject('认证失败，错误码'), // 用户无权限
  '100022': reject('您暂无此权限'), // 用户无权限
  '100023': reject('帐号已被封禁', {
    url: isMobilePlatform ? '/mobile.html#/entry?code=100023' : '/index.html#/account-banned',
    isIntra: true, // 内部跳转
  }),
  '100024': reject('帐号未入驻', {
    // url: isMobilePlatform ? '/mobile.html#/entry?code=100024' : '/to_reg.html#changeAccount',
    url: isMobilePlatform ? '/mobile.html#/entry?code=100024' : '/index.html#/to_reg',
    // isIntra: isMobilePlatform, // 内部跳转
    // url: isMobilePlatform ? '/mobile.html#/entry?code=100000' : '/index.html#/account-protect',
    isIntra: true, // 内部跳转
  }),
  '100027': reject('帐号无MCN管理权限，即将跳转至开放平台！', {
    url: '/subscribe_v3/index.html',
    showTip: true,
  }),
  '100028': reject('帐号已被注销', {
    url: isMobilePlatform ? '/mobile.html#/entry?code=100028' : '/index.html#/account-cancel',
    isIntra: true, // 内部跳转
  }),
  '100063': reject('无法操作该直播'), // 无法操作该直播
  '100064': reject(), // 直播室信息不存在
  '100604': reject('您的帐号未上线'), // 用户无权限
  '100040': reject('帐号已被预注销', {
    url: isMobilePlatform ? '/mobile.html#/entry?code=100040' : '/index.html#/account-pre-cancel',
    isIntra: true, // 内部跳转
  }),
  '100032': reject('帐号不支持入驻', {
    url: isMobilePlatform ? '/mobile.html#/entry?code=100040' : '/index.html#/account-refused',
    isIntra: true, // 内部跳转
  }),
  other: reject(),
};

// 校验返回结果
const proofResponse = response => {
  const rs = response.data;
  return (
    rs &&
    (status[rs.code] !== undefined ? status[rs.code](response, rs) : status.other(response, rs))
  );
};

// 构造axios请求实例
export const request = axios.create({
  baseURL: modifyUrl('/wemedia'),
  method: 'get',
  headers: modifyHeader({
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
  withCredentials: true, // default
  timeout: 60 * 1000, // 1 min
  responseType: 'json',
  paramsSerializer: params => transformRequest(params),
  transformRequest: [
    (data, headers) => {
      if (isObject(data) && headers['Content-Type'] !== 'multipart/form-data') {
        return transformRequest(data);
      }
      return data;
    },
  ],
  // transformResponse: [(data) => {
  //     return proofResponse(data);
  // }],
});

// 用来设置全局预设值
// 在 ./main/Index.js 文件中引用过
export const defaultParams = { _: +new Date() };

let onlyOneErrorAlert = false;

/*
 * @param {object} config - 请求配置
 * @param {function} done - 请求成功时调用
 * @param {function} fail - 请求失败时调用
 * @param {boolean} noModal - 是否不显示弹窗
 *
 * @return {promise}
 *
 * 常规调用方式：
 * ajax('url', rs => rs);
 * ajax('url', {}, rs => rs);
 *
 * 失败处理的方式：
 * ajax('url', {}, rs => rs，error => error);
 *
 * 不弹出错窗口：
 * ajax('url', {}, rs => rs，error => error, true);
 *
 * */
const ajax = (
  url,
  config,
  done = noop,
  fail = noop,
  noModal = false,
  throwError = false,
  preHandler = true,
) => {
  if (!isObject(config)) {
    if (isFunction(config)) {
      fail = done;
      done = config;
    }
    config = {};
  }
  config.url = url;
  config.params = extend({}, defaultParams, config.params || {});
  const traceId = getTraceId();
  const wholeLink = new WholeLink();
  wholeLink.setTraceId(traceId);
  const wholeLinkHeaders = {
    'X-NR-Trace-Id': traceId,
    'X-B3-SpanId': 0,
    'X-B3-Sampled': 1,
  };
  if (isReportWholeLink) config.headers = extend({}, config.headers, wholeLinkHeaders);
  wholeLink.setStartTime(new Date().getTime());

  return request
    .request(config)
    .then(response => {
      wholeLink.setEndTime(new Date().getTime());
      wholeLink.setTags(config, response);
      if (isReportWholeLink) wholeLink.sendData();
      return preHandler ? proofResponse(response) : response;
    })
    .then(response => (done ? done(response.data) : response))
    .catch(error => {
      if (process.env.NODE_ENV === 'development' && config.mock) {
        console.log(config);
        return done ? done(config.mock) : config.mock;
      }
      wholeLink.setEndTime(new Date().getTime());
      wholeLink.setTags(config, error);
      if (isReportWholeLink) wholeLink.sendData();
      const data = error.data;
      if (axios.isCancel(error)) {
        console.log(error.message);
        return data;
      }

      fail && fail(error);

      if (error.response) {
        // 服务器响应出错
        // 状态码非2xx错误
        error.message = '很抱歉，服务异常，请稍等片刻再次尝试！';
        // 可收集出错信息：error.response.headers['x-host-ip']
      } else {
        // debugger;
        // 自定义错误 或 无响应
        if (data && data.url) {
          if (data.showTip && !onlyOneErrorAlert && !noModal) {
            Modal.warning({
              title: '提示',
              vertical: 'middle',
              content: data ? data.msg : error.message || '未知错误！',
              onClose: (...argv) => {
                onlyOneErrorAlert = false;
                if (data.newWindow) {
                  window.open(data.url);
                } else {
                  window.location.href = data.url;
                }
              },
            });
          } else if (data.newWindow) {
            window.open(data.url);
          } else {
            window.location.href = data.url;
          }
          // 区分 站内站外 为了页面让在跳转前区分需不需要做渲染
          return data.isIntra ? data : Promise.reject(data);
        }
        if (error.code === 'ECONNABORTED') {
          error.message = '很抱歉，服务超时，请稍等片刻再次尝试！';
        }
        if (error.message === 'Network Error') {
          error.message = '网络连接异常';
        }
      }
      console.error('Error', error);

      if (!onlyOneErrorAlert && !noModal) {
        onlyOneErrorAlert = true;
        Modal.warning({
          title: '提示',
          vertical: 'middle',
          content: data ? data.msg : error.message || '未知错误！',
          onClose: (...argv) => {
            onlyOneErrorAlert = false;
          },
        });
      }
      return throwError || config.throwError ? Promise.reject(data) : data;
    });
};

export default ajax;
